import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app.module';

platformBrowserDynamic().bootstrapModule(AppModule).then(function(appRef){
	(<any>window).applicationInjector = appRef.injector;
});



// WEBPACK FOOTER //
// ./src/app/main.ts